import { IsBoolean } from "class-validator";

export class TemplateDetailsGeneralFieldDto {
  @IsBoolean()
  visible!: boolean;
}
